import { render, staticRenderFns } from "./NsIcon.vue?vue&type=template&id=356f1bc1&scoped=true&"
import script from "./NsIcon.vue?vue&type=script&lang=js&"
export * from "./NsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NsIcon.vue?vue&type=style&index=0&id=356f1bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f1bc1",
  null
  
)

export default component.exports